import useAccount from '../../hooks/useAccount';

export default function useAccountFilter() {
  const account = useAccount();

  return {
    accountId: account.id
  };
};
